import { useMemo } from 'react';
import { minSecondStartDate } from '../../../utils/vacationFractioning';
import { findFirstSelectableStartDate, isSelectableStartDate } from '../../../utils/vacationStartDateRules';

export interface UseVacationDateBoundsParams {
    earliestStartDate?: string | null;
    scheduleLimitDate?: string | null;
    firstEndDate: string;
    holidays?: string[];
}

export function useVacationDateBounds({
    earliestStartDate,
    scheduleLimitDate,
    firstEndDate,
    holidays = [],
}: UseVacationDateBoundsParams) {
    const firstStartDefaultMonth = useMemo(
        () => findFirstSelectableStartDate(new Date(), earliestStartDate, holidays, scheduleLimitDate),
        [earliestStartDate, scheduleLimitDate, holidays]
    );

    const secondStartDefaultMonth = useMemo(
        () => (firstEndDate ? minSecondStartDate(firstEndDate) : undefined),
        [firstEndDate]
    );

    const isStartDateSelectable = (iso: string) =>
        isSelectableStartDate(iso, new Date(), earliestStartDate, holidays, scheduleLimitDate);
    const isSecondStartSelectable = (iso: string) =>
        isSelectableStartDate(iso, new Date(), earliestStartDate, holidays, scheduleLimitDate) &&
        (!firstEndDate || iso > firstEndDate);

    return {
        firstStartDefaultMonth,
        secondStartDefaultMonth,
        isStartDateSelectable,
        isSecondStartSelectable,
    };
}
